import { render, staticRenderFns } from "./DetalheChamado.vue?vue&type=template&id=5028c0f2&scoped=true"
import script from "./DetalheChamado.vue?vue&type=script&lang=js"
export * from "./DetalheChamado.vue?vue&type=script&lang=js"
import style0 from "./DetalheChamado.vue?vue&type=style&index=0&id=5028c0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028c0f2",
  null
  
)

export default component.exports